// extracted by mini-css-extract-plugin
export default {"link":"src-components-Link-css__link--2oAvy","disable":"src-components-Link-css__disable--zgId3"};